import React from "react";
import { Link, useLocation } from "react-router-dom";
import "../BinTransfer/BinTransferMain.css";
import { ArrowForwardIos } from "@mui/icons-material";

function EasyPutAway_BreadCrumbs() {
  const location = useLocation();
  const vPathName = location.pathname;
  return (
    <div className="container-fluid ">
      {vPathName === "/EasyPutAway" ? (
        <div>
          <span className="breadcrumb-not-active ">EasyPutAway </span>
        </div>
      ) : vPathName === "/EasyPutAwayDetail" ? (
        <div className={"d-flex align-items-center"}>
          <Link
            to="/EasyPutAway"
            state={location}
            className={"breadcrumb-active mr-2"}
          >
            EasyPutAway
          </Link>
          <ArrowForwardIos color="info" style={{ marginRight: "1px" }} />
          <div>
            <span className="breadcrumb-not-active">EasyPutAwayDetail </span>
          </div>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}
export default EasyPutAway_BreadCrumbs;
